/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ColorWheel from '../components/ColorWheel';
import ColorMode from '../components/ColorMode';
import ColorSliders from '../components/ColorSliders';
import ColorRgb from '../components/ColorRgb';
import ColorGrid from '../components/ColorGrid';
import Favorites from '../components/Favorites';
import StringResources from 'nls/StringResources';
import {
	Tabs,
	TabPanel,
	Dialog,
	Link,
	FlexLayout,
	FlexItem
} from '@ba/ba-ui-carbon-toolkit';
import '../../stylesheets/all.scss';


const MAX_FAVORITES = 12;

// CustomPalette class
export default class CustomColorDialog extends Component {

	static propTypes = {
		isDialogOpen: PropTypes.bool,
		glassContext: PropTypes.object,
		paletteService: PropTypes.object,
		onChange: PropTypes.func,
		onCloseDialog: PropTypes.func
	}
	static defaultProps = {
		isDialogOpen: false
	};

	// Constructor
	// State consists of property to define whether or not the dialog is open or closed, the selectedTab for the tab panel and the selected item in the select drop down list
	constructor(props) {
		super(props);

		this.favoritesView = null;
		this.state = {
			currentColor: null,
			isDialogOpen: props.isDialogOpen || false,
			selectedTab: 'idColorGrid',
			selectedColorType: 'RGB'
		};
	}

	componentDidMount() {
		const paletteServicePromise = this.props.paletteService? Promise.resolve(this.props.paletteService) : this.props.glassContext.getSvc('.Palette');
		paletteServicePromise.then((service) => {
			service.getFavoriteColors().then((cmFavoriteColors) => {
				this.favoritesView.setState({
					favoriteColors: cmFavoriteColors
				});
			});
		});
	}

	updateSelectedColor(color){
		this.setState({
			currentColor: color
		});
	}

	setColor(color) {
		this.updateSelectedColor(color);
		if (this.favoritesView.isFavoriteSelected()) {
			this.favoritesView.updateSelectedColor(color);
			this.favoritesView.deselectCurrentFavorite();
		}
	}

	addFavorite() {
		if(this.state.currentColor && this.favoritesView.state.favoriteColors.length < MAX_FAVORITES){
			let colors = this.favoritesView.state.favoriteColors;
			colors.push(this.state.currentColor);
			this.favoritesView.setState({
				favoriteColors: colors
			});
		}
	}

	applyPaletteColor = () => {
		const paletteServicePromise = this.props.paletteService? Promise.resolve(this.props.paletteService) : this.props.glassContext.getSvc('.Palette');
		paletteServicePromise.then((service) => {
			service.setFavoriteColors(this.favoritesView.getFavoriteColors()).then(() => {
				this.props.onChange(this.state.currentColor);
				this.closeDialog();
			}, (error) => {
				console.log(error);
			});
		});
	}

	closeDialog = () => {
		this.setState({ isDialogOpen: false });
		if(this.props.onCloseDialog){
			this.props.onCloseDialog();
		}
	}

	openDialog = () => {
		this.setState({ isDialogOpen: true });
	}

	render() {
		return (
			(this.state.isDialogOpen &&
			(
				<Dialog width='481px' onClose={this.closeDialog} className="customColorDialog">
					<Dialog.Header>{StringResources.get('colorPicker')}</Dialog.Header>
					<Dialog.Body>
						<Tabs selected={this.state.selectedTab} onChange={tabId => this.setState({ selectedTab: tabId })} style={{ height: '375px' }}>
							<TabPanel keepTabContent={true} id={'idColorGrid'} label={StringResources.get('grid')}>
								<div style={{ marginTop: '16px' }}>
									<ColorGrid
										id={'idColorGridComponent'}
										onColorChange={this.setColor.bind(this)}
									/>
								</div>
							</TabPanel>
							<TabPanel keepTabContent={true} id={'idColorWheel'} label={StringResources.get('wheel')}>
								<FlexLayout style={{ marginTop: '16px' }}>
									<FlexItem>
										<div>
											<ColorWheel
												id='idColorWheelComponent'
												onColorChange={this.setColor.bind(this)}
												color={this.state.currentColor}
											/>
										</div>
										<div style={{ marginTop: '16px', width: '160px' }}>
											<ColorMode
												selectedColorType={this.state.selectedColorType}
												onChange={value => this.setState({ selectedColorType: value })}
											/>
										</div>
									</FlexItem>
									<FlexItem style={{ marginLeft: '16px' }}>
										<ColorRgb
											onChange={this.setColor.bind(this)}
											color={this.state.currentColor}
										/>
										<ColorSliders
											onColorChange={this.setColor.bind(this)}
											selectedColorType={this.state.selectedColorType}
											color={this.state.currentColor}
											style={{ marginTop: '16px' }}
										/>
									</FlexItem>
								</FlexLayout>
							</TabPanel>
						</Tabs>
						<FlexLayout direction='column'>
							<FlexLayout justifyContent='flex-end'>
								<Link className='addFavorite' style={{ zIndex: 3000 }} onClick={this.addFavorite.bind(this)}>{StringResources.get('setAsFavorite')}</Link>
							</FlexLayout>
							<Favorites
								favoriteColors={[]}
								updateColor={this.updateSelectedColor.bind(this)}
								ref={(element) => { this.favoritesView = element; } }
								numberOfFavorites={MAX_FAVORITES}>
							</Favorites>
						</FlexLayout>
					</Dialog.Body>
					<Dialog.Footer>
						<Dialog.Button label={StringResources.get('cancelDialog')} onClick={this.closeDialog} />
						<Dialog.Button label={StringResources.get('applyDialog')} onClick={this.applyPaletteColor} disabled={!this.state.currentColor} primary/>
					</Dialog.Footer>
				</Dialog>
			)) || null
		);
	}
}

CustomColorDialog.defaultProps = {
	name: 'CustomColorDialog'
};



// WEBPACK FOOTER //
// ./src/js/dialog/CustomColorDialog.js